/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-misused-promises */

'use client'

import React, { useState, useEffect } from 'react'
import { WidgetType } from '@enums/WidgetType'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import Cookies from 'js-cookie'
import { WebViewActions, callWebviewHandlerV2 } from '@utils/webview'
import { autoService } from '@services/autoService'
import { processAssetData } from '@utils/assethelper'
import { VARIANT_ID } from '@components/Product/ProductWidget/constants'
import { deepLinkConfig } from '@configs/deeplink.config'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { waitForAnalyticsLoad } from '@components/utils/analyticsViewPage'
import { getProductName } from '@components/MainWidget/ChallanWidgetLanding/helper'
import { useUserContext } from '@context/UserContext/UserContenxt'
import { LayoutFlags, NO_CHALLAN_SUBHEADING_FINAL, whatsappLoadingScreens } from './constants'
import RewardSectionWidget from './RewardSectionWidget'
import WhatsappChallanLoadingScreen from './whatsappChallanLoadingScreen'
import styles from './whatsappChallan.module.scss'
import PendingChallanWidget from './PendingChallanWidget'
import DownloadAppButton from './DownloadAppButton'
import VehicleInfoHeader from './VehicleInfoHeader'
import MonthlyRewardCard from './MonthlyRewardCard'
import CenteredImage from './CenteredImage'
import { getLayoutFlags, vehicleType } from './helper'

const WhatsappChallanFlow = ({ regNum, phoneNumber, segmentEventCommonProperties, widgetType }) => {
  const [loadingComplete, setLoadingComplete] = useState(false)
  const [flags, setFlags] = useState<LayoutFlags | null>(null)
  const [vehicleData, setVehicleData] = useState([])
  const [vehicleImage, setVehicleImage] = useState('')
  const { isLoggedIn } = useUserContext()

  const handleLoadingComplete = () => {
    setLoadingComplete(true)
  }

  useEffect(() => {
    const fetchVehicleDataAndImage = async () => {
      try {
        const vehicleResponse = await autoService(regNum)
        setVehicleData(vehicleResponse || [])

        if (vehicleResponse?.[VARIANT_ID]) {
          const vehicleImageResponse = await processAssetData(vehicleResponse, '/api/app/')
          setVehicleImage(vehicleImageResponse?.variantDetails || '')
        }
      } catch (error) {
        console.error('Error fetching vehicle data or image:', error)
      }
    }
    fetchVehicleDataAndImage()
  }, [])

  useEffect(() => {
    const fetchLayout = async () => {
      const resolvedFlags = await getLayoutFlags(isLoggedIn, regNum, phoneNumber)
      setFlags(resolvedFlags)
    }
    fetchLayout()
  }, [isLoggedIn])

  useEffect(() => {
    if (Cookies.get('webview')) {
      callWebviewHandlerV2({
        url: deepLinkConfig[WidgetType.CHALLAN_WIDGET_LANDING],
        action: WebViewActions.OPEN_DEEPLINK,
      })
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)

      waitForAnalyticsLoad().then(() => {
        pageEvent(SEGMENT.VIEW_PAGE, {
          ...properties,
          product: getProductName(),
          journey: 'challan',
          phone: phoneNumber || '',
          registration_number: regNum || '',
          vehicle_type: vehicleType(vehicleData) || 'N/A',
          mm_name: vehicleData?.model_name || '',
          previous_policy_expiry_date: vehicleData?.previous_policy_expiry_detail || '',
          expiry_date: vehicleData?.previous_policy_expiry_detail || '',
          vas_amount: null,
        }).catch(err => {
          console.log('Wait for analytics load error', err)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
      })
    })()
  }, [])
  return (
    <div className={styles.seeWhatsappFlow}>
      {!loadingComplete ? (
        <WhatsappChallanLoadingScreen
          screens={whatsappLoadingScreens}
          duration={1000}
          onComplete={handleLoadingComplete}
        />
      ) : (
        <div className={styles.whatsappChallanContainer}>
          <VehicleInfoHeader regNum={regNum} vehicleImage={vehicleImage} vehicleData={vehicleData} />
          <div className={styles.pageDivider} />
          {flags?.showCenteredImage && <CenteredImage subHeading={NO_CHALLAN_SUBHEADING_FINAL} />}
          {flags?.showRewardSectionWidget && (
            <RewardSectionWidget
              vehicleData={vehicleData}
              proposalData={flags?.proposalData}
              redirectUrl={flags?.proposalData?.redirect_url}
              amount={flags?.proposalData?.coupon_amount}
              segmentEventCommonProperties={segmentEventCommonProperties}
              regNo={regNum}
              phone={phoneNumber}
            />
          )}

          {flags?.showPendingChallanWidget && (
            <PendingChallanWidget isVerified={isLoggedIn} dynamicChallan={flags.challanData} />
          )}
          {flags?.showMonthlyRewardCard && (
            <MonthlyRewardCard regNo={regNum} widgetType={widgetType} phone={phoneNumber} vehicleData={vehicleData} />
          )}
          {flags?.showDownloadAppButton && (
            <DownloadAppButton regNum={regNum} phoneNumber={phoneNumber} vehicleData={vehicleData} />
          )}
        </div>
      )}
    </div>
  )
}

export default WhatsappChallanFlow
